
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UINotificationService } from '../../core/providers/ui-notification.service';
import { SessionProvider } from '../../core/providers/session.provider';

export interface ComponentCanDeactivate {
  canDeactivate: () => boolean | Observable<boolean>;
  onBeforeLeave?: () => void;
}

@Injectable()
export class PendingChangesGuard  {
  constructor(
    private notificationService: UINotificationService,
    private session: SessionProvider) {
  }
  canDeactivate(component: ComponentCanDeactivate): boolean | Promise<boolean> {
    if (component.canDeactivate()) {
      return true;
    } else {
      return new Promise<boolean>(async (resolve) => {
        const result = await this.notificationService.showModalMessage({
          title: $localize`:@@UI.Common.UnsavedChanges.Title:Módosítások elvetése`,
          message: $localize`:@@UI.Common.UnsavedChanges.ConfirmLeaveQuestion:A módosításaid nem kerültek mentésre. Elveted a módosításokat?`,
          buttons: ['cancel', 'ok'],
          buttonBgColor: [this.session.isDarkMode() ? 'var(--mdc-protected-button-container-color)' : '#fff'],
          buttonColor: ['#000', 'accent'],
          type: 'warning',
        });
        if (result === 'ok') {
          component.onBeforeLeave?.();
          resolve(true);
        } else {
          resolve(false);
        }
      });
    }
  }
}
